import { ICopyButtonStyle } from '../models/index.js';
export const CopyButtonStyle: ICopyButtonStyle = {
	border: {
		_value: 'none',
	},
	background: {
		_value: 'none',
	},
};
